
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAILURE = 'LOGIN_FAILURE';

export const FETCH_ICDATA_REQUEST = 'FETCH_ICDATA_REQUEST';
export const FETCH_ICDATA_SUCCESS = 'FETCH_ICDATA_SUCCESS';
export const FETCH_ICDATA_FAILURE = 'FETCH_ICDATA_FAILURE';

export const DOWNLOAD_SOURCE_REQUEST = 'DOWNLOAD_SOURCE_REQUEST';
export const DOWNLOAD_SOURCE_SUCCESS = 'DOWNLOAD_SOURCE_SUCCESS';
export const DOWNLOAD_SOURCE_FAILURE = 'DOWNLOAD_SOURCE_FAILURE';

export const FETCH_JOBS_REQUEST = 'FETCH_JOBS_REQUEST';
export const FETCH_JOBS_SUCCESS = 'FETCH_JOBS_SUCCESS';
export const FETCH_JOBS_FAILURE = 'FETCH_JOBS_FAILURE';
export const SAVE_JOBS_SUCCESS = 'SAVE_JOBS_SUCCESS';

export const SAVE_CALCDETAILS_REQUEST = 'SAVE_CALCDETAILS_REQUEST';
export const SAVE_CALCDETAILS_SUCCESS = 'SAVE_CALCDETAILS_SUCCESS';
export const SAVE_CALCDETAILS_FAILURE = 'SAVE_CALCDETAILS_FAILURE';

export const FETCH_COLUMN_METADATA_REQUEST = 'FETCH_COLUMN_METADATA_REQUEST';
export const FETCH_COLUMN_METADATA_SUCCESS = 'FETCH_COLUMN_METADATA_SUCCESS';
export const FETCH_COLUMN_METADATA_FAILURE = 'FETCH_COLUMN_METADATA_FAILURE';

export const SAVE_JOB_REQUEST = 'SAVE_JOB_REQUEST';
export const SAVE_JOB_SUCCESS = 'SAVE_JOB_SUCCESS';
export const SAVE_JOB_FAILURE = 'SAVE_JOB_FAILURE';